import { getFileTypeIconAsUrl } from "@fluentui/react-file-type-icons";
import { officeFileType } from "../../config/constants";
import { ISearchOpenFileInfo } from "../../interfaces/ISearchOpenFileInfo";
import { BrandIcons } from "../../config/brandIcons";

export class SearchOpenExtensionHelper {
    private static msWord: ISearchOpenFileInfo = { iconSrc: BrandIcons.Word16, type: officeFileType.Word, isOfficeFile: true, officeOnlineEditorAvailable: true, localUrlPrepended: "ms-word:ofe|u|" };
    private static msExcel: ISearchOpenFileInfo = { iconSrc: BrandIcons.Excel16, type: officeFileType.Excel, isOfficeFile: true, officeOnlineEditorAvailable: true, localUrlPrepended: "ms-excel:ofe|u|" };
    private static msPowerpoint: ISearchOpenFileInfo = { iconSrc: BrandIcons.PowerPoint16, type: officeFileType.Powerpoint, isOfficeFile: true, officeOnlineEditorAvailable: true, localUrlPrepended: "ms-powerpoint:ofe|u|" };

    private static msVisio: ISearchOpenFileInfo = { iconSrc: getFileTypeIconAsUrl({ extension: ".vsdx", size: 20, imageFileType: "svg" }), type: officeFileType.Visio, isOfficeFile: true, localUrlPrepended: "ms-visio:ofe|u|" };
    private static msAccess: ISearchOpenFileInfo = { iconSrc: getFileTypeIconAsUrl({ extension: ".accdb", size: 20, imageFileType: "svg" }), type: officeFileType.Access, isOfficeFile: true, localUrlPrepended: "ms-access:ofe|u|" };
    private static msProject: ISearchOpenFileInfo = { iconSrc: getFileTypeIconAsUrl({ extension: ".mpp", size: 20, imageFileType: "svg" }), type: officeFileType.Project, isOfficeFile: true, localUrlPrepended: "ms-project:ofe|u|" };
    private static msPublisher: ISearchOpenFileInfo = { iconSrc: getFileTypeIconAsUrl({ extension: ".pub", size: 20, imageFileType: "svg" }), type: officeFileType.Publisher, isOfficeFile: true, localUrlPrepended: "ms-publisher:ofe|u|" };
    private static msInfopath: ISearchOpenFileInfo = { iconSrc: getFileTypeIconAsUrl({ extension: ".xsn", size: 20, imageFileType: "svg" }), type: officeFileType.Infopath, isOfficeFile: true, localUrlPrepended: "ms-infopath:ofe|u|" };
    private static msOneNote: ISearchOpenFileInfo = { iconSrc: BrandIcons.OneNote16, type: officeFileType.OneNote, isOfficeFile: true, localUrlPrepended: "onenote:" };

    private static browser: ISearchOpenFileInfo = { iconName: "BrowserTab", type: officeFileType.Browser, localUrlPrepended: "" };
    private static app: ISearchOpenFileInfo = { iconName: "CloneToDesktop", type: officeFileType.App, localUrlPrepended: "" };

    private static validExtensionsDictionary = {
        "doc": SearchOpenExtensionHelper.msWord,
        "docx": SearchOpenExtensionHelper.msWord,
        "docm": SearchOpenExtensionHelper.msWord,
        "dotm": SearchOpenExtensionHelper.msWord,
        "dotx": SearchOpenExtensionHelper.msWord,
        "dot": SearchOpenExtensionHelper.msWord,
        "odt": SearchOpenExtensionHelper.msWord,

        "xls": SearchOpenExtensionHelper.msExcel,
        "xlsx": SearchOpenExtensionHelper.msExcel,
        "xlsb": SearchOpenExtensionHelper.msExcel,
        "xlsm": SearchOpenExtensionHelper.msExcel,
        "ods": SearchOpenExtensionHelper.msExcel,

        "pptx": SearchOpenExtensionHelper.msPowerpoint,
        "ppsx": SearchOpenExtensionHelper.msPowerpoint,
        "ppt": SearchOpenExtensionHelper.msPowerpoint,
        "pps": SearchOpenExtensionHelper.msPowerpoint,
        "pptm": SearchOpenExtensionHelper.msPowerpoint,
        "potm": SearchOpenExtensionHelper.msPowerpoint,
        "ppam": SearchOpenExtensionHelper.msPowerpoint,
        "potx": SearchOpenExtensionHelper.msPowerpoint,
        "ppsm": SearchOpenExtensionHelper.msPowerpoint,
        "pot": SearchOpenExtensionHelper.msPowerpoint,
        "odp": SearchOpenExtensionHelper.msPowerpoint,

        "vsdx": SearchOpenExtensionHelper.msVisio,
        "vsx": SearchOpenExtensionHelper.msVisio,
        "vtx": SearchOpenExtensionHelper.msVisio,
        "vdx": SearchOpenExtensionHelper.msVisio,
        "vdw": SearchOpenExtensionHelper.msVisio,
        "vsd": SearchOpenExtensionHelper.msVisio,
        "vsdm": SearchOpenExtensionHelper.msVisio,
        "vsl": SearchOpenExtensionHelper.msVisio,
        "vss": SearchOpenExtensionHelper.msVisio,
        "vssm": SearchOpenExtensionHelper.msVisio,
        "vssx": SearchOpenExtensionHelper.msVisio,
        "vst": SearchOpenExtensionHelper.msVisio,
        "vstm": SearchOpenExtensionHelper.msVisio,
        "vstx": SearchOpenExtensionHelper.msVisio,

        "accdb": SearchOpenExtensionHelper.msAccess,
        "laccdb": SearchOpenExtensionHelper.msAccess,
        "mdb": SearchOpenExtensionHelper.msAccess,
        "adp": SearchOpenExtensionHelper.msAccess,
        "accdr": SearchOpenExtensionHelper.msAccess,
        "accdc": SearchOpenExtensionHelper.msAccess,
        "accde": SearchOpenExtensionHelper.msAccess,

        "mpp": SearchOpenExtensionHelper.msProject,
        "mpt": SearchOpenExtensionHelper.msProject,
        "mpx": SearchOpenExtensionHelper.msProject,

        "pub": SearchOpenExtensionHelper.msPublisher,

        "xsn": SearchOpenExtensionHelper.msInfopath,
        "xsf": SearchOpenExtensionHelper.msInfopath,
        "xsl": SearchOpenExtensionHelper.msInfopath,

        "onenotenotebook": SearchOpenExtensionHelper.msOneNote,
        "onetoc2": SearchOpenExtensionHelper.msOneNote,
        "one": SearchOpenExtensionHelper.msOneNote,
    };

    public static determineOfficeFileType = (extension: string): ISearchOpenFileInfo => {
        if (extension) {
            return SearchOpenExtensionHelper.validExtensionsDictionary[extension.replace(".", "").trim().toLowerCase()]
                ?? SearchOpenExtensionHelper.app;
        }
        return SearchOpenExtensionHelper.browser;
    };
}